import React from 'react';
import Otto from './Otto';
import './otto.css';

// Loading state — Otto in the flying pose HOVERS (stationary) above an
// indeterminate teal bar with a subtle up-down bob. Drop-in replacement
// for the old TurboLoader (same size/message API). Not flying across —
// stationary hover. Reduced-motion stills the hover + bar via otto.css.
const SIZE_MAP = { small: 48, medium: 60, large: 84 };

export default function OttoLoading({ size = 'medium', message }) {
  const px = SIZE_MAP[size] || SIZE_MAP.medium;
  // Caption should be relevant to whatever's loading — callers pass a
  // page-specific message; the fallback stays generic (never the
  // supplier-search line, which only fits supplier contexts).
  const caption = message
    ? `${String(message).replace(/[.…\s]+$/, '')}…`
    : 'Loading…';
  return (
    <div className="flex flex-col items-center justify-center gap-3.5 py-10" role="status" aria-live="polite">
      <div className="otto-hover" style={{ display: 'flex' }}>
        <Otto pose="flying-empty" size={px} ariaLabel="" />
      </div>
      <div className="otto-loadbar" style={{ width: 260, height: 7 }}><span /></div>
      <p className="font-['Metropolis'] text-sm font-semibold text-ink-secondary">{caption}</p>
    </div>
  );
}
